/**
 * Product Card Siblings
 *
 * 1. Hover ueber Swatch → Card-Bild auf Sibling-Bild swappen
 * 2. Mouse-Leave der Card → Original-Bild wiederherstellen
 * 3. Click auf Swatch → zum Sibling navigieren UND verhindern dass
 *    der aeussere <a> auch navigiert
 *
 * Mouseover/click via Event-Delegation (document-level).
 * Mouseleave per direktem Listener (mouseleave blubbert nicht und
 * mouseout ist unzuverlaessig bei verschachtelten Elementen).
 * MutationObserver fuer dynamisch geladene Cards (AJAX-Filter etc.)
 */

(function () {
  if (window.__siblingCardInit) return;
  window.__siblingCardInit = true;

  function getCardImage(card) {
    return card.querySelector('img.product-card--image');
  }

  function rememberOriginalSrc(img) {
    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.currentSrc || img.src;
      img.dataset.originalSrcset = img.srcset || '';
    }
  }

  function swapToSibling(card, siblingImageUrl) {
    const img = getCardImage(card);
    if (!img) return;
    rememberOriginalSrc(img);
    img.src = siblingImageUrl;
    img.srcset = '';
    img.removeAttribute('sizes');
    card.classList.add('is-sibling-hover');
  }

  function restoreOriginal(card) {
    const img = getCardImage(card);
    card.classList.remove('is-sibling-hover');
    if (!img || !img.dataset.originalSrc) return;
    img.src = img.dataset.originalSrc;
    img.srcset = img.dataset.originalSrcset || '';
  }

  function clearActiveSwatches(card) {
    card.querySelectorAll('.product-card--sibling-swatch.is-active')
        .forEach(s => s.classList.remove('is-active'));
  }

  // Pro Card eine pending Restore-Aktion (damit Swatch-Wechsel
  // ohne Flackern moeglich ist)
  const pendingRestores = new WeakMap();

  function scheduleRestore(card, delay) {
    cancelRestore(card);
    const timer = setTimeout(() => {
      restoreOriginal(card);
      clearActiveSwatches(card);
      pendingRestores.delete(card);
    }, delay);
    pendingRestores.set(card, timer);
  }

  function cancelRestore(card) {
    const timer = pendingRestores.get(card);
    if (timer) {
      clearTimeout(timer);
      pendingRestores.delete(card);
    }
  }

  function handleCardLeave(e) {
    const card = e.currentTarget;
    // Sofortiger Restore wenn man die ganze Card verlaesst
    cancelRestore(card);
    restoreOriginal(card);
    clearActiveSwatches(card);
  }

  function handleSwatchLeave(e) {
    const swatch = e.currentTarget;
    const card = swatch.closest('.product-card--root');
    if (!card) return;
    // Verzoegerung damit der Wechsel auf einen anderen Swatch
    // (mouseover) den Restore wieder cancelen kann
    scheduleRestore(card, 80);
  }

  // === Direkte mouseleave Listener pro Card mit Siblings ===
  function attachCardListeners() {
    const cards = document.querySelectorAll('.product-card--root');
    cards.forEach(card => {
      if (card.dataset.siblingsBound) return;
      const swatches = card.querySelectorAll('.product-card--sibling-swatch');
      if (swatches.length === 0) return;
      card.dataset.siblingsBound = '1';
      card.addEventListener('mouseleave', handleCardLeave);
      // Pro Swatch ein mouseleave - sofortiger (verzoegerter) Restore
      swatches.forEach(s => s.addEventListener('mouseleave', handleSwatchLeave));
    });
  }

  // Initial + bei DOM-Aenderungen (Filter, AJAX-Loads)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachCardListeners);
  } else {
    attachCardListeners();
  }

  const mo = new MutationObserver(function () {
    attachCardListeners();
  });
  mo.observe(document.body, { childList: true, subtree: true });

  // === Click: zum Sibling navigieren, Card-Link Click verhindern ===
  document.addEventListener('click', function (e) {
    const swatch = e.target.closest('.product-card--sibling-swatch');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();
    const url = swatch.dataset.siblingUrl;
    if (url) window.location.href = url;
  }, true);

  // === Keyboard (Enter/Space) ===
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const swatch = e.target.closest('.product-card--sibling-swatch');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();
    const url = swatch.dataset.siblingUrl;
    if (url) window.location.href = url;
  });

  // === Hover ueber Swatch: Bild swappen ===
  document.addEventListener('mouseover', function (e) {
    const swatch = e.target.closest('.product-card--sibling-swatch');
    if (!swatch) return;
    const card = swatch.closest('.product-card--root');
    if (!card) return;
    // Pending Restore canceln (Wechsel zwischen Swatches ohne Flackern)
    cancelRestore(card);
    const siblingImage = swatch.dataset.siblingImage;
    if (siblingImage) {
      swapToSibling(card, siblingImage);
      clearActiveSwatches(card);
      swatch.classList.add('is-active');
    }
  });
})();
